import { CSSProperties, useState } from 'react';
import { useConfiguration } from '../../context/ConfigurationContext';
import ocifLogo from '../../assets/OCIF.png';

export const Logo = ({ style, width = 72, height = 72 }: { style?: CSSProperties; width?: number | string; height?: number | string }) => {
  const configuration = useConfiguration();
  const LOGO_SRC = configuration?.LOGO_SRC;
  const [src, setSrc] = useState(LOGO_SRC || ocifLogo);

  return <img src={ocifLogo} style={style} width={width === 'auto' ? height : width} height={height} alt="logo" onError={() => setSrc(ocifLogo)} />;
};
